<div class="modal notification-modal" tabindex="-1" role="dialog" *ngIf="activateModal">
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="modal-header">
                <button type="button" class="close" (click)="closeModal()" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                <h4 class="modal-title">Choose a selection to edit</h4>
            </div>
            <div class="modal-body">
                <div class="row pb-1">
                    <div class="col-md-7"><input type="text" [(ngModel)]="search" placeholder="Search" (keyup)="filterTitles()" [disabled]="!initialized"></div>
                    <div class="col-md-5">
                        <div class="pipeline-checkbox"><input type="checkbox" id="filterNew" (click)="runFilterNew()"  [checked]="filterNew" [disabled]="!initialized"><label for="filterNew">New Content Only</label></div>
                        <div *ngIf="isDevMode()" class="pipeline-checkbox"><input type="checkbox" id="filterUnpublished" (click)="toggleShowOnlyUnpublishedTitles()" [checked]="showOnlyUnpublishedTitles"><label for="filterUnpublished">Unpublished/Test Titles Only</label></div>
                    </div>
                </div>
                <div class="pipeline-list">
                    <div class="loading-state mt-1" *ngIf="filteredTitles.length === 0">
                        <img src="../../img/loading.svg" />
                    </div>
                    <ul *ngFor="let title of !showOnlyUnpublishedTitles ? filteredTitles : unpublishedTitles" class="list list-group list-group-flush list-group-item-action">
                        <button type="button" (click)="selectTitle(title.referenceStory)" class="list-group-item list-group-item-action selectableTitle">{{ title.shortTitle }} - ({{title.referenceStory}})</button>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</div>
